import { HEX_COLOR_PATTERN, SPLASH_APPEARANCE_STORAGE_KEY } from '@/app/consts/interfaceAppearance';
import { type SplashScreenAppearance } from '@/app/models/SplashScreenAppearance';
import { SplashScreenType } from '@/app/models/SplashScreenType';

export const readSplashAppearance = (sessionToken?: string): SplashScreenAppearance | undefined => {
  if (!sessionToken) return;
  try {
    const branding: unknown = JSON.parse(localStorage.getItem(SPLASH_APPEARANCE_STORAGE_KEY) || 'null');
    if (typeof branding !== 'object' || branding === null) return;
    if (!('sessionToken' in branding) || branding.sessionToken !== sessionToken) return;
    if (
      !('type' in branding) ||
      (branding.type !== SplashScreenType.IMAGE && branding.type !== SplashScreenType.LOTTIE)
    )
      return;
    if (
      !('backgroundColor' in branding) ||
      typeof branding.backgroundColor !== 'string' ||
      !HEX_COLOR_PATTERN.test(branding.backgroundColor)
    )
      return;
    if (
      !('darkBackgroundColor' in branding) ||
      typeof branding.darkBackgroundColor !== 'string' ||
      !HEX_COLOR_PATTERN.test(branding.darkBackgroundColor)
    )
      return;
    const mediaUrl = 'mediaUrl' in branding && typeof branding.mediaUrl === 'string' ? branding.mediaUrl : undefined;
    return {
      type: branding.type,
      mediaUrl,
      backgroundColor: branding.backgroundColor,
      darkBackgroundColor: branding.darkBackgroundColor,
    };
  } catch {
    // Dados locais inválidos não podem impedir a abertura do sistema.
  }
};

export const clearSplashAppearance = () => {
  try {
    localStorage.removeItem(SPLASH_APPEARANCE_STORAGE_KEY);
  } catch {
    // O armazenamento indisponível não interfere na autenticação.
  }
};

export const saveSplashAppearance = (sessionToken: string, appearance: SplashScreenAppearance) => {
  try {
    const branding = JSON.stringify({ sessionToken, ...appearance });
    localStorage.setItem(SPLASH_APPEARANCE_STORAGE_KEY, branding);
  } catch {
    // Esta referência só antecipa a mídia enquanto o bundle e a API carregam.
  }
};
